import { render, staticRenderFns } from "./CaptaindataStatus.vue?vue&type=template&id=472f31a2&scoped=true"
import script from "./CaptaindataStatus.vue?vue&type=script&lang=js"
export * from "./CaptaindataStatus.vue?vue&type=script&lang=js"
import style0 from "./CaptaindataStatus.vue?vue&type=style&index=0&id=472f31a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "472f31a2",
  null
  
)

export default component.exports